import React from 'react'
import { CardContainer } from './styles'

export const Card = ({ children, ...props }) => {
  return <CardContainer {...props}>{children}</CardContainer>
}
